// extracted by mini-css-extract-plugin
export default {"card":"W0-z","carouselContainer":"X0-z","carouselContent":"Y0-z"};